import $ from 'jquery';
import * as d3 from 'd3';

function isitChartable(data){
  for (let d of data){
    if ((d.stickerPriceOnCampus || d.stickerPriceOffCampus) && d.netPrice){
        return true;
      };
  }
}

export function runData(datafile, metric_type, targetId, year, level) {
var data_t = []
var revenues = []
var exps = []
if (level == 1) {
 revenues = [131891447, 135594968.5,  140230607.5, 146977121, 144690982] 
 exps = [133675645.5, 125578819, 136528269,  144456114,143128147]
} else if (level == 2) {
  revenues = [33315527, 29643637,   28021561, 32195734 ,31233769 ] 
  exps = [ 29153942, 29230709,  29002692  , 29035000 , 29164840 ]
} else if (level == 4) {
  revenues = [35661747,  35596411 , 35457961.5 , 35573599 , 36271524.5 ] 
exps = [33717949,  33703872.5,  33807626.5,  34763516,  35479213 ] 
}

data_t.push({"school":"Median", "revenue":revenues[year],"expenses": exps[year]})
data_t.push({"school":datafile.institution, "revenue":datafile.revenue[year].value, "expenses":datafile.expenses[year].value})

if (metric_type == "revenue"){
  data_t.sort(function (a, b) {
    return b.revenue - a.revenue;
  })
} else {
  data_t.sort(function (a, b) {
    return b.expenses - a.expenses;
  })
}
 



var defaults = {
    margin: {top: 0, right: 0, bottom: 0, left: 10},
    rootname: "TOP",
    format: ",d",
    title: "",
    width: 220,
    height: 120
};
const idTarget = '#' + targetId

  $(idTarget).width(defaults.width).height(defaults.height);
  var width = defaults.width - defaults.margin.left - defaults.margin.right,
      height = defaults.height - defaults.margin.top - defaults.margin.bottom
  
  var x = d3.scaleSqrt()
      .domain([0, width])
      .range([0, width]);
    var x2 = d3.scaleLinear()
      .domain([0, width])
      .range([0, width]);
  
  var y = d3.scaleSqrt()
      .domain([0, height])
      .range([0, height]);

  d3.select(idTarget).select('svg').remove()

  var svg = d3.select(idTarget).append("svg")
      .attr("width", width + defaults.margin.left + defaults.margin.right)
      .attr("height", height + defaults.margin.bottom + defaults.margin.top)
    .append("g")
      .attr("transform", "translate(" + defaults.margin.left + "," + defaults.margin.top + ")")
      .style("shape-rendering", "crispEdges");

  const max = d3.max([d3.max(data_t, (d)=>{
    return d.revenue
  }), d3.max(data_t, (d)=>{
    return d.expenses
  })])

  x.domain([0, max])

  y.domain([0, max])

  const rev_diff = x(data_t[0].revenue) - x(data_t[1].revenue)
  const exp_diff = x(data_t[0].expenses) - x(data_t[1].expenses)

  svg.selectAll(".bar")
      .data(data_t)
      .enter()
        .append("rect")
        .classed("bar", true)
        // .attr("rx", 6)
        // .attr("ry", 6)
        .attr("x", (d,i)=>{
          if (metric_type == "revenue") {
            return width - x(d.revenue);
          } else {
            return 0;
          }
        })
        .attr("y", (d,i)=>{
          if (metric_type == "revenue") {
            return height - y(d.revenue);
          } else {
            return height - y(d.expenses);
          }
        })
        .attr("height", (d,i)=>{
          if (metric_type == "revenue") {
            return y(d.revenue);
          } else {
            return y(d.expenses)
          }
        })
        .attr("width", (d,i)=>{
          if (metric_type == "revenue") {
            return x(d.revenue);
          } else {
            return x(d.expenses)
          }
        }).attr("fill", (d)=>{
          if (metric_type == "revenue") {
            if (d.school != "Average") {
              return "#697b9f"
            } else {
              return "#536382"
            }
          } else {
            if (d.school != "Average") {
              return "#825b53"
            } else {
              return "#63453f"
            }
          }
          
          
        })
        .attr('stroke', 'white')
        .attr('stroke-width', '2')

  svg.append('text')
    .classed('smaller-text', true)
    .attr('x', ()=>{
      if (metric_type == "revenue") {
        return width - 5;
      } else {
        return 5;
      }
    })
    .attr('y', ()=>{
      if (metric_type == "revenue") {
          if (rev_diff <= 100) {
              return height - y(data_t[1].revenue) + 12
            } else {
              return height - y(data_t[1].revenue) - 4
            }
          } else {
            if (exp_diff <= 100) {
              return height - y(data_t[1].expenses) + 12
            } else {
              return height - y(data_t[1].expenses) - 4
            }
          }
        }
      )
    .attr('text-anchor',()=>{
      if (metric_type == "revenue") {
        return 'end';
      } else {
        return 'beginning';
      }
    })
      .attr("font-size", 10)
      .text(data_t[1].school)
      .attr("fill", "white")
      .attr('font-family', 'National')
      .style('text-transform', 'uppercase')

  svg.append('text')
    .classed('larger-text', true)
    .attr('x', ()=>{
      if (metric_type == "revenue") {
        return width - x(data_t[0].revenue) + 6 ;
      } else {
        return x(data_t[0].expenses) - 6;
      }
    })
    .attr('y', ()=>{
      if (metric_type == "revenue") {
        if (rev_diff > 20) {
          return height - y(data_t[0].revenue) + 14
        } else {
          return height - y(data_t[0].revenue);
        }
        
      } else {
        if (exp_diff > 20) {
          return height - y(data_t[0].expenses) + 14
        } else {
          return height - y(data_t[0].expenses);
        }
      }
    })
    .attr('text-anchor',()=>{
      if (metric_type == "revenue") {
        return 'beginning';
      } else {
        return 'end';
      }
    })
      .attr("font-size", 10)
      .text(data_t[0].school)
      .attr("fill", "white")
      .attr('font-family', 'National')
      .style('text-transform', 'uppercase')


}


export default {runData}